import React, { useEffect, useState } from "react";
import {
    Box,
    Button
} from "@mui/material";
import {
    makePOSTRequestOnUserService,
} from "../../Api/api";
import { ITRData } from "../Users/OfficeUseActions";
import { generateOfficeUsePdf } from "../Users/createOfficeUsePdf";

export interface OfficeUseActionsProps {
    panData: any;
    poa: any;
    bank_details?: any[];
    demat_details?: any[];
    currentUser?: any;
    user_type?: any;
}

export interface OfficeUsePdfPayload {
    user: string;
    panCard: any;
    poa: any;
    bank_details: any[];
    demat_details: any[];
    itrData: ITRData | null;
}

export const OfficeUseActions = ({ panData, poa, bank_details = [], demat_details = [], currentUser, user_type }: OfficeUseActionsProps) => {
    const toastr = require("toastr");
    const [itrData, setITRData] = useState<ITRData | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        if (!panData?.uuid) {
            setLoading(false);
            return;
        }
        makePOSTRequestOnUserService(`/partneruser/pan/itr_compliance/`, {
            user_type: user_type,
            pan_number: panData?.uuid,
        })
            .then((resp) => {
                if (active && [201, 200].includes(resp.status)) {
                    setITRData(resp.data);
                }
            })
            .catch((error) => toastr.error(error))
            .finally(() => {
                active && setLoading(false);
            });
        return () => {
            active = false;
        };
    }, [loading]);

    const handleDownloadButton = () => {
        try {
            const payload: OfficeUsePdfPayload = {
                user: currentUser?.uuid,
                panCard: panData,
                poa,
                bank_details,
                demat_details,
                itrData,
            };

            generateOfficeUsePdf(payload);
        } catch (error) {
            console.error("Failed to generate compliance PDF", error);
            toastr.error("Unable to download the compliance snapshot. Please retry.");
        }
    };

    return (
        <Box sx={{ m: "0 auto" }}>
            {loading ? (
                "Fetching ITR Compliance Information..."
            ) : (
                <>
                    <Button
                        variant="contained"
                        onClick={() => handleDownloadButton()}
                        sx={{ m: 1 }}
                    >
                        Download User Data
                    </Button>
                </>
            )}
        </Box>
    );
};